import React from 'react';
import { Button } from '@/components/ui/button';
import { Menu, Moon, Sun } from 'lucide-react';
import { CommonLabel } from '@/components/ui/common-label';
import { NotificationMenu } from './NotificationMenu';
import { ProfileMenu } from './profileMenu';
import { useAuth } from '@/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';


export function Header({ theme, toggleTheme, toggleSidebar, currentPageTitle }) {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = async () => {
    await logout();
    navigate('/login');
  };

  const iconButtonClasses = 
    `rounded-[13px] shadow-[0px_4.9px_19.6px_0px_#6A73811F] border border-border focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0`; 

  return (
    <header className="h-14 bg-card/70 backdrop-blur-sm flex items-center justify-between px-4 sm:px-6 flex-shrink-0 sticky top-0 z-20 shadow-[0px_0px_16px_rgba(17,17,26,0.05)]">
      <div className="flex items-center gap-2 sm:gap-4">
        <Button
          variant="none"
          size="icon"
          onClick={toggleSidebar}
          className={iconButtonClasses}
        >
          <Menu className="w-5 h-5" />
        </Button>

        <div className="hidden sm:block">
          <CommonLabel size="xl" weight="bold" className="text-foreground">
            {currentPageTitle}
          </CommonLabel>
        </div>
      </div>

      <div className="flex items-center gap-2 sm:gap-3">
        <Button
          variant="none"
          size="icon"
          onClick={toggleTheme}
          className={iconButtonClasses}
        >
          {theme === 'dark' ? <Sun className="w-5 h-5 text-yellow-400" /> : <Moon className="w-5 h-5 text-foreground/80 dark:text-slate-300" />}
        </Button>
        <NotificationMenu theme={theme} />
        <ProfileMenu theme={theme} onLogout={onLogout} />
      </div>
    </header>
  );
}